// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:46:34

export default {
  "id": "airport-controller",
  "slug": "airport-controller",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/2a5e3480843b4ae299debb9f829f6f97-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/2a5e3480843b4ae299debb9f829f6f97/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Airport Controller",
      "description": "Take control in Airport Controller Game! Manage planes, guide safe landings, refuel, repair, and board passengers while handling growing airport traffic. Test your skills in this fast-paced simulation and keep everything running smoothly. Play now!",
      "instructions": "Move Plane - Drag with mouse to take the plane to the desired location\nPause - P",
      "genres": [
        "Simulation",
        "Strategy"
      ],
      "tags": [
        "airplane",
        "airport",
        "control",
        "time",
        "traffic"
      ]
    },
    "zh-CN": {
      "title": "机场管制员",
      "description": "在机场控制器游戏中掌握控制权！管理飞机、引导安全降落、加油、维修和登机乘客，同时处理日益增长的机场交通。在这款紧张刺激的模拟游戏中测试你的技能，让一切运行顺畅。现在就玩！",
      "instructions": "移动飞机 - 用鼠标拖动飞机到想要的位置\n暂停 - P",
      "genres": [
        "模拟",
        "策略"
      ],
      "tags": [
        "飞机",
        "机场",
        "控制",
        "时间",
        "交通"
      ]
    },
    "zh-TW": {
      "title": "機場管制員",
      "description": "掌控機場管制遊戲！管理飛機，引導安全著陸，加油，維修，並登記乘客，同時處理日益增多的機場交通。在這個高速度模擬遊戲中挑戰你的技巧，並保持一切運作順暢。現在就開始遊戲！",
      "instructions": "移動飛機 - 用滑鼠拖曳飛機到想要的位置\n暫停 - P",
      "genres": [
        "模擬",
        "策略"
      ],
      "tags": [
        "飛機",
        "機場",
        "控制",
        "時間",
        "交通"
      ]
    },
    "zh-HK": {
      "title": "機場塔台控制員",
      "description": "掌握機場控制遊戲！管理飛機，引導安全降落，加油、維修及上客，同時處理日漸增多的機場交通。在這個快速節奏的模擬遊戲中挑戰你的技巧，保持一切運作順暢。立即遊玩！",
      "instructions": "移動飛機 - 用鼠標拖曳將飛機帶到目標位置\n暫停 - P",
      "genres": [
        "模擬",
        "策略"
      ],
      "tags": [
        "飛機",
        "機場",
        "管制",
        "時間",
        "交通"
      ]
    },
    "ja": {
      "title": "空港管制官",
      "description": "空港管制ゲームで統率を取ろう！飛行機を管理し、安全な着陸を案内し、燃料補給、修理、乗客の搭乗を手がけながら増加する空港の交通を処理しよう。高速なシミュレーションであなたのスキルを試しながら、すべてをスムーズに運営し続けよう。今すぐプレイ！",
      "instructions": "移動パネル - マウスでドラッグして、飛行機を希望する場所に移動\n一時停止 - P",
      "genres": [
        "シミュレーション",
        "戦略"
      ],
      "tags": [
        "航空機",
        "空港",
        "管制",
        "時間",
        "交通"
      ]
    },
    "ko": {
      "title": "공항 조종사",
      "description": "에어포트 컨트롤러 게임에서 통제력을 쥐어라! 비행기를 관리하고 안전한 착륙을 지도하며 재燃料, 수리, 승객 탑승을 처리하면서 성장하는 공항 교통을 다스려라. 이 빠른 시뮬레이션에서 자신의 기술을 테스트하고 모든 것이 원활하게 운영되도록 해라. 지금 즉시 플레이하세요!",
      "instructions": "이동 비행기 - 마우스로 끌어서 비행기를 원하는 위치로 이동\n일시정지 - P",
      "genres": [
        "시뮬레이션",
        "전략"
      ],
      "tags": [
        "비행기",
        "공항",
        "제어",
        "시간",
        "교통"
      ]
    },
    "fr": {
      "title": "Contrôleur d'aéroport",
      "description": "Prenez le contrôle dans le jeu Airport Controller ! Gérez des avions, guidez des atterrissages sécurisés, ravitaillez, réparez et embarquez des passagers tout en gérant la circulation croissante de l'aéroport. Testez vos compétences dans cette simulation rapide et assurez que tout fonctionne sans encombre. Jouez maintenant !",
      "instructions": "Déplacer l'avion - Glisser avec la souris pour emmener l'avion à l'emplacement souhaité\nPause - P",
      "genres": [
        "Simulation",
        "Stratégie"
      ],
      "tags": [
        "avion",
        "aéroport",
        "contrôle",
        "temps",
        "trafic"
      ]
    }
  }
};
